// removed by extract-text-webpack-plugin
module.exports = {"navigation":"navigation_2O91w","active":"active_essOL","container":"container_1FPmQ","user":"user_2WFiR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/header/style.css
 ** module id = 945
 ** module chunks = 0
 **/